//#region types
import { BaseFormFieldProps, WintHorizontalFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import FormField from "./formField";
//#endregion

export type HorizontalFormFieldProps<T extends BaseFormFieldProps> = WintHorizontalFormFieldProps & T;

function HorizontalFormField<T extends BaseFormFieldProps>(props: HorizontalFormFieldProps<T>) {
  return <FormField<T> {...props} direction="horizontal" />;
}

export default HorizontalFormField;
